import { doodModalConfig } from './dood-modal-config';
import { propertyValue } from './dood-block-config';
import {
  buildOrderedBlockDescriptor,
  type DescriptorFieldOrderItem,
} from './descriptor-field-order';
import type { IBlockDescriptor } from './descriptor';

/** Serializable category row shown under a composable product in the studio preview. */
export type ProductAddModalPreviewCategory = {
  store_id: string;
  name: string;
  description?: string;
  count: number;
  min_count: number;
};

/** Serializable product shown in the CB2 studio preview of this modal. */
export type ProductAddModalPreviewProduct = {
  id: string;
  name: string;
  description?: string;
  price: number;
  final_price: number;
  type: 'DECLINABLE';
  available: boolean;
  images?: {
    cover?: { url: string };
    thumbnail?: { url: string };
  };
  categories: readonly {
    store_id: string;
    store: string;
    count: number;
    min_count: number;
    products: readonly string[];
  }[];
};

/** Preview fixture for `ProductAddModalComponent`. The live modal reads the cart product instead. */
export type ProductAddModalScenarioContent = {
  product: ProductAddModalPreviewProduct;
  categories: readonly ProductAddModalPreviewCategory[];
};

export const PRODUCTADDMODAL_LEGACY_FIELD_ORDER = [
  { type: 'heading', value: "Couleurs" },
  "background_color",
  "heading_color",
  "description_color",
  "inactive_state_color",
  "price_color",
  { type: 'separator' },
  "hide_addition_group_details"
] as const satisfies readonly DescriptorFieldOrderItem[];

const {
  productAddModalDescriptor: _generatedProductAddModalDescriptor,
  productAddModalModalDefinition,
  productAddModalDashboardLayout,
  productAddModalConfig,
  productAddModalResolveConfig,
  productAddModalProperties,
  productAddModalDefinitionSetupScenarios,
} = doodModalConfig(
  {
    name: "Product add modal",
    handle: "product-add-modal",
    internal_name: "ProductAddModal",
    componentType: 'ProductAddModalComponent',
    category: 'modal',
    description: "Product add modal.",
    keywords: [],
    isContentModal: true,
    defaultHandle: "product-add-modal",
    sharedFields: {}
  },

  () => ({
    background_color: propertyValue({
      type: 'color',
      value: {"type":"hex","value":"#FFFFFF"},
      options: {
        "label": "Couleur de fond"
      }
    }),
    heading_color: propertyValue({
      type: 'color',
      value: {"type":"palette","value":"neutral-900"},
      options: {
        "label": "Titres produits"
      }
    }),
    description_color: propertyValue({
      type: 'color',
      value: {"type":"palette","value":"neutral-700"},
      options: {
        "label": "Description"
      }
    }),
    inactive_state_color: propertyValue({
      type: 'color',
      value: {"type":"palette","value":"neutral-500"},
      options: {
        "label": "Etat inactif"
      }
    }),
    price_color: propertyValue({
      type: 'color',
      value: {"type":"palette","value":"neutral-700"},
      options: {
        "label": "Prix"
      }
    }),
    hide_addition_group_details: propertyValue({
      type: 'checkbox',
      value: false,
      options: {
        "label": "Hide the text info of the number of product to choose"
      }
    })
  }),

  () => ({
    tabs: [
      {
        label: 'Design',
        fieldsets: [
          {
            legend: 'Properties',
            fields: ["background_color", "heading_color", "description_color", "inactive_state_color", "price_color", "hide_addition_group_details"],
          },
        ],
      },
    ],
  })
);

export function productAddModalDescriptor(): IBlockDescriptor;
export function productAddModalDescriptor(
  fieldOrder: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor;
export function productAddModalDescriptor(
  fieldOrder?: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor {
  if (fieldOrder === undefined) {
    return _generatedProductAddModalDescriptor;
  }
  return buildOrderedBlockDescriptor(_generatedProductAddModalDescriptor, productAddModalProperties, fieldOrder);
}

export {
  productAddModalModalDefinition,
  productAddModalDashboardLayout,
  productAddModalProperties,
  productAddModalConfig,
  productAddModalResolveConfig,
  productAddModalDefinitionSetupScenarios,
};

export type ProductAddModalConfig = typeof productAddModalConfig;
